import React from 'react'

interface HelpMenuItem {
  label: string
  onClick: () => void
}

interface HelpMenuProps {
  items: HelpMenuItem[]
}

/**
 * Popover content for the left-nav Help button. Renders the supplied items as
 * a flat list of menu rows; the caller is responsible for the click side
 * effects (navigation, mailto, closing the popover).
 */
export const HelpMenu: React.FC<HelpMenuProps> = ({ items }) => {
  return (
    <div className="p-1.5" data-popover-menu>
      {items.map((item) => (
        <button
          key={item.label}
          type="button"
          onClick={item.onClick}
          className="group flex items-center w-full px-3 py-[10px] bg-transparent border-0 rounded-lg cursor-pointer outline-none text-left transition-colors hover:!bg-neutral-100"
        >
          <span className="text-sm font-medium tracking-[-0.2px] text-neutral-700 group-hover:text-neutral-900">
            {item.label}
          </span>
        </button>
      ))}
    </div>
  )
}
